import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const ACTION_CONFIG = {
  suspend: {
    title: 'Suspender Usuario',
    description: '¿Está seguro que desea suspender a este usuario? No podrá acceder al sistema hasta ser reactivado.',
    icon: 'UserX',
    iconBg: 'bg-red-100',
    iconColor: '#DC2626',
    confirmVariant: 'danger',
    confirmLabel: 'Suspender',
  },
  reactivate: {
    title: 'Reactivar Usuario',
    description: '¿Está seguro que desea reactivar a este usuario? Recuperará acceso al sistema.',
    icon: 'UserCheck',
    iconBg: 'bg-emerald-100',
    iconColor: '#059669',
    confirmVariant: 'success',
    confirmLabel: 'Reactivar',
  },
  activate: {
    title: 'Activar Usuario',
    description: '¿Está seguro que desea activar este usuario? Se le enviará una notificación por correo.',
    icon: 'CheckCircle',
    iconBg: 'bg-emerald-100',
    iconColor: '#059669',
    confirmVariant: 'success',
    confirmLabel: 'Activar',
  },
  reject: {
    title: 'Rechazar Solicitud',
    description: '¿Está seguro que desea rechazar esta solicitud de registro? Esta acción no se puede deshacer.',
    icon: 'XCircle',
    iconBg: 'bg-red-100',
    iconColor: '#DC2626',
    confirmVariant: 'danger',
    confirmLabel: 'Rechazar',
  },
  reset_password: {
    title: 'Restablecer Contraseña',
    description: 'Se enviará un enlace de restablecimiento de contraseña al correo del usuario.',
    icon: 'Key',
    iconBg: 'bg-amber-100',
    iconColor: '#D97706',
    confirmVariant: 'warning',
    confirmLabel: 'Enviar enlace',
  },
  bulk_activate: {
    title: 'Activar Usuarios Seleccionados',
    description: 'Se activarán todos los usuarios seleccionados y recibirán notificación por correo.',
    icon: 'CheckCircle',
    iconBg: 'bg-emerald-100',
    iconColor: '#059669',
    confirmVariant: 'success',
    confirmLabel: 'Activar todos',
  },
  bulk_suspend: {
    title: 'Suspender Usuarios Seleccionados',
    description: 'Se suspenderán todos los usuarios seleccionados. No podrán acceder al sistema.',
    icon: 'UserX',
    iconBg: 'bg-red-100',
    iconColor: '#DC2626',
    confirmVariant: 'danger',
    confirmLabel: 'Suspender todos',
  },
  bulk_export: {
    title: 'Exportar Usuarios',
    description: 'Se exportará la lista de usuarios seleccionados en formato CSV.',
    icon: 'Download',
    iconBg: 'bg-blue-100',
    iconColor: '#0891B2',
    confirmVariant: 'default',
    confirmLabel: 'Exportar',
  },
};

const ActionConfirmModal = ({ action, user, selectedCount, onConfirm, onCancel }) => {
  const config = ACTION_CONFIG?.[action] || ACTION_CONFIG?.suspend;
  const isBulk = action?.startsWith('bulk_');

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onCancel} />
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-md p-6 z-10">
        <div className="flex items-start gap-4 mb-5">
          <div className={`w-12 h-12 rounded-xl ${config?.iconBg} flex items-center justify-center flex-shrink-0`}>
            <Icon name={config?.icon} size={22} color={config?.iconColor} />
          </div>
          <div>
            <h3 className="text-base font-bold text-gray-800 font-heading">{config?.title}</h3>
            {!isBulk && user && (
              <p className="text-sm text-gray-500 font-caption mt-0.5">{user?.name} — {user?.organization}</p>
            )}
            {isBulk && (
              <p className="text-sm text-gray-500 font-caption mt-0.5">{selectedCount} usuario{selectedCount !== 1 ? 's' : ''} seleccionado{selectedCount !== 1 ? 's' : ''}</p>
            )}
          </div>
        </div>
        <p className="text-sm text-gray-600 font-body mb-6">{config?.description}</p>
        <div className="flex gap-3 justify-end">
          <Button variant="outline" onClick={onCancel}>Cancelar</Button>
          <Button variant={config?.confirmVariant} onClick={onConfirm}>{config?.confirmLabel}</Button>
        </div>
      </div>
    </div>
  );
};

export default ActionConfirmModal;